// extracted by mini-css-extract-plugin
export default {"favHeader":"styles_favHeader__nTVOS","header":"styles_header__8ydC8","closeButton":"styles_closeButton__ULP+t"};